import styled from '@emotion/styled/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CalendarSkipPreviousDateButton = styled.button<{
  windowWidth: number
}>`
  background: none;
  border: none;
  border-radius: 50px;
  color: #989898;
  height: 38px;
  transition: background 0.8s;
  width: ${({ windowWidth }) => (windowWidth < 410 ? '0' : '38px')};
  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    border-radius: 50px;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const CalendarSkipPreviousIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
`

export const CalendarDropDownPrevious = styled.div`
  background-color: #fff;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  display: none;
  margin: 0;
  min-width: 120px;
  position: absolute;
  right: 0;
  text-align: center;
  z-index: 150;
`

export const CalendarSkipPreviousDateButtonWrapper = styled.div`
  display: inline-block;
  position: relative;
  &:hover ${CalendarDropDownPrevious} {
    display: block;
  }
`

export const CalendarDropDownPreviousContent = styled.p`
  background: white;
  color: #3c4043;
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  opacity: 1;
  padding: 12px 16px;
  text-decoration: none;
  text-transform: none;

  &:hover {
    background-color: #f1f3f4;
    cursor: pointer;
  }
`

export const CalendarPreviousDateButton = styled.button`
  background: none;
  border: none;
  border-radius: 50px;
  color: #989898;
  height: 38px;
  transition: background 0.8s;
  width: 38px;
  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    border-radius: 50px;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const CalendarPreviousIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
`
